<template>
   <div>
      <h3 class="section-title">Commissions</h3>

      <fieldset v-if="!isVBCustomInvitation" class="border p-2 marb-24 mart-24">
         <legend class="w-auto">Commission Statement(s)</legend>
         <sched-pdf v-for="(pth, indx) in docPathArray" :key="indx" :docpath="pth" title="CommissionStatement" :downloadfiletype="downloadfiletype" :keepdefaultcss="keepdefaultcss"></sched-pdf>

         <section-bar class="mart-12">Signature</section-bar>
         <div v-if="gettingSigs">
            <i class="fas fa-spinner fa-spin ml-orange fa-lg"></i>
         </div>
         <div v-else>
            <p class="instructions">Please sign the above document(s) by entering the following information:</p>
            <div class="form-group row">
               <label for="sigDate" class="col-sm-2 col-form-label" 
                  :class="{ 'error--label': v$.signatures.$dirty && v$.signatures.hasSigSchedDt.$invalid }">Date</label>
               <div class="col-sm-4">
                  <input type="date" class="form-control" id="sigDate" placeholder="(MM/DD/YYYY)" :readonly="$parent.readOnly()"
                     v-model="signatures[sigCommDt].signatureValue" @change="chg"  @blur="v$.signatures.$touch()"
                     :class="{ 'error--input': v$.signatures.$dirty && v$.signatures.hasSigSchedDt.$invalid }">
                  <div class="error--msg" v-if="v$.signatures.$dirty && v$.signatures.hasSigSchedDt.$invalid">
                     Date is Required
                  </div>
               </div>
            </div>
            <div class="form-group row">
               <label for="comAgentName" class="col-sm-2 col-form-label" 
                  :class="{ 'error--label': v$.signatures.$dirty && v$.signatures.hasSigAgt.$invalid }">Agent Name</label>
               <div class="col-sm-4">
                  <input type="text" class="form-control" id="comAgentName" placeholder="(agent name)" :readonly="$parent.readOnly()"
                     v-model="signatures[sigCommAgt].signatureValue" @change="chg" @blur="v$.signatures.$touch()" 
                     :class="{ 'error--input': v$.signatures.$dirty && v$.signatures.hasSigAgt.$invalid }">
                  <div class="error--msg" v-if="v$.signatures.$dirty && v$.signatures.hasSigAgt.$invalid">
                     Agent Name is Required
                  </div>
               </div>
               <label for="commmName" class="col-sm-2 col-form-label"
                  :class="{ 'error--label': v$.signatures.$dirty && v$.signatures.hasSigSched.$invalid }">Mother's Maiden Name</label>
               <div class="col-sm-4">
                  <input type="text" class="form-control" id="commmName" placeholder="(mother's maiden name)" :readonly="$parent.readOnly()"
                     v-model="signatures[sigComm].signatureValue" @change="chg" @blur="v$.signatures.$touch()" 
                     :class="{ 'error--input': v$.signatures.$dirty && v$.signatures.hasSigSched.$invalid }">
                  <div class="error--msg" v-if="v$.signatures.$dirty && v$.signatures.hasSigSched.$invalid">
                     {{ v$.signatures.hasSigSched.$message }}
                  </div>
               </div>
            </div>
         </div>
      </fieldset>

      <section-bar>Commission Remittance Selection</section-bar>
      <template v-if="showType(['R','P', 'VR'])">
         <div class="custom-control custom-radio custom-control-inline">
            <input class="custom-control-input" id="commissionRemitTypeCodeR" type="radio" name="rtyp" :disabled="$parent.readOnly()"
               value="COMRMT_TYP_ASGN" v-model="remitanceType" @change="chg" selected>
            <label class="custom-control-label" for="commissionRemitTypeCodeR">
               <b>Assignment</b> - I want to Assign my Commission
            </label>
         </div>
         <p class="ml-corp smaller padt-12">
            Note: The "Assignment of Commissions" form must be filled out and can be found in 
            the Supporting Documents section of this application.
         </p>
         
         <p><strong>Please provide the Agent / Agency Information</strong></p>
         <fieldset id="CRSFields">
         <div class="form-group row">
            <field-col name="commissionRemitAssign.agentAgencyName" label="Agent/Agency Name" v-model="agentAgencyName" :v$="v$.commissionRemitAssign.agentAgencyName" @change="chg" lcols="2" icols="4"></field-col>
            <field-col :show="maskedSsn == undefined || maskedSsn == ''" name="commissionRemitAssign.ssnTaxID" label="SSN/Tax ID#" v-model="ssnTaxID" :v$="v$.commissionRemitAssign.ssnTaxID" @change="chg" lcols="2" icols="4"></field-col>
            <label v-show="maskedSsn != undefined && maskedSsn != ''" for="commissionRemitAssign.ssnTaxID" class="col-form-label col-sm-2">SSN/Tax ID#</label>
            <div v-show="maskedSsn != undefined  && maskedSsn != ''" class="col-sm-4">
               <input v-show="maskedSsn != undefined && maskedSsn != ''"
                  type="Text"
                  class="form-control"
                  id="commissionRemitAssign.ssnTaxID"
                  v-model="maskedSsn"
                  readonly="readOnly"
               />
            </div>
         </div>
         <div class="form-group row">
            <field-col name="commissionRemitAssign.address1" label="Address" v-model="address1" :v$="v$.commissionRemitAssign.address1" @change="chg" lcols="2" icols="4"></field-col>
            <field-col name="commissionRemitAssign.city" label="City" v-model="city" :v$="v$.commissionRemitAssign.city" @change="chg" lcols="2" icols="4"></field-col>
         </div>
         <div class="form-group row">
         
            <label for="agency" class="col-sm-2 col-form-label">State</label>
            <div class="col-sm-4">
               <select class="form-control" aria-placeholder="(choose a state)" :disabled="$parent.readOnly()"
                  v-model="stateCode" @change="chg">
                  <option :value="null" disabled hidden>(Choose a State)</option>
                  <option value="AA">Asia</option>
                  <option value="AK">Alaska</option>
                  <option value="AL">Alabama</option>
                  <option value="AR">Arkansas</option>
                  <option value="AS">American Samoa</option>
                  <option value="AZ">Arizona</option>
                  <option value="BC">British Columbia</option>
                  <option value="CA">California</option>
                  <option value="CM">Northern Mariana Islands</option>
                  <option value="CN">Canada</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DC">District of Columbia</option>
                  <option value="DE">Delaware</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="GU">Guam</option>
                  <option value="HI">Hawaii</option>
                  <option value="IA">Iowa</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="LT">Latin America</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MD">Maryland</option>
                  <option value="ME">Maine</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MO">Missouri</option>
                  <option value="MS">Mississippi</option>
                  <option value="MT">Montana</option>
                  <option value="NB">New Brunswick</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="NE">Nebraska</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NV">Nevada</option>
                  <option value="NY">New York</option>
                  <option value="OC">Foreign Country</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="PR">Puerto Rico</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VA">Virginia</option>
                  <option value="VI">Virgin Islands</option>
                  <option value="VT">Vermont</option>
                  <option value="WA">Washington</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WV">West Virginia</option>
                  <option value="WY">Wyoming</option>
               </select>
               <div class="error--msg" v-if="v$.commissionRemitAssign.stateCode.$error">
                  {{ v$.commissionRemitAssign.stateCode.required.$message }}
               </div>
            </div>
            <field-col name="commissionRemitAssign.zip" label="ZipCode" v-model="zip" :v$="v$.commissionRemitAssign.zip" @change="chg" lcols="2" icols="4"></field-col>
         </div>
         </fieldset>
      </template>
      <template v-else>
         <div class="mart-24">
            <div class="custom-control custom-radio custom-control-inline marb-12">
               <input class="custom-control-input" id="commissionRemitTypeCode" type="radio" name="rtyp" :disabled="$parent.readOnly()"
                      value="COMRMT_TYP_DIRECT" v-model="remitanceType" @change="chg">
               <label class="custom-control-label" for="commissionRemitTypeCode" :class="{ 'error--label': v$.commissionRemitTypeCode.$error }">
                  <span v-if="isVBInvitation"><b>Direct Deposit</b> - I will be paid weekly with a $25 minimum.</span>
                  <span v-else><b>Direct Deposit</b> - I will be paid 2 times each month for all companies (15th and End of Month) with a $25 minimum.</span>
               </label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
               <input class="custom-control-input" id="r2" type="radio" name="rtyp" :disabled="$parent.readOnly()"
                  value="COMRMT_TYP_PAPER" v-model="remitanceType" @change="chg">
               <label class="custom-control-label" for="r2" :class="{ 'error--label': v$.commissionRemitTypeCode.$error }">
                  <b>Paper check</b> - I will be receive my paper check once each month (last business day). We will not cut a check for less than $100.
               </label>
            </div>
            <div class="error--msg" v-if="v$.commissionRemitTypeCode.$error">
               {{ v$.commissionRemitTypeCode.required.$message }}
            </div>

            <div v-if="remitanceType == 'COMRMT_TYP_DIRECT'">
               <p class="mart-24 font-smaller"><strong>Please provide the Bank Account information for Direct Deposit setup.</strong></p>

               <div class="form-group row">
                  <field-col name="bankInfo.bankName" label="Bank Name" v-model="banking.bankName" :v$="v$.bankInfo.bankName" @change="chg" lcols="2" icols="4"></field-col>
                  
                  <field-col name="bankInfo.routingNumber" label="Routing Number" v-model="banking.routingNumber" :v$="v$.bankInfo.routingNumber" @change="chg" lcols="2" icols="4"></field-col>
               </div>
               <div class="form-group row">
                  <label for="acctTypeCode" class="col-form-label col-sm-2" :class="{ 'error--label': v$.bankInfo.accountTypeCode.$error }">Account Type</label>
                  <div class="col-sm-4">
                     <select class="form-control" aria-placeholder="(choose a Type)" id="acctTypeCode" :disabled="$parent.readOnly()"
                        @blur="v$.bankInfo.accountTypeCode.$touch" @change="chg" 
                        v-model="banking.accountTypeCode" :class="{ 'error--input': v$.bankInfo.accountTypeCode.$error }">
                        <option :value="null" disabled hidden>(Choose a Type)</option>
                        <option value="ACCTTYP_SAVINGS">Savings</option>
                        <option value="ACCTTYP_CHECKING">Checking</option>
                     </select>
                     <div class="error--msg" v-if="v$.bankInfo.accountTypeCode.$error">
                        {{ v$.bankInfo.accountTypeCode.required.$message }}
                     </div>
                  </div>
                  <field-col name="bankInfo.accountNumber" label="Account Number" v-model="banking.accountNumber" :v$="v$.bankInfo.accountNumber" @change="chg" lcols="2" icols="4"></field-col>
               </div>
               <div class="form-group row">
                  <field-col name="bankInfo.accountName" label="Account Name" v-model="banking.accountName" :v$="v$.bankInfo.accountName" @change="chg" lcols="2" icols="4"></field-col>
               </div>
            </div>
         </div>

      </template>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from "moment";
import FieldCol from "../fieldCol.vue";
import SchedPdf from "./pdfViewer.vue";

export default {
   name: "commisionsPanel",
   components: {
      'field-col': FieldCol,
      'sched-pdf': SchedPdf
   },
   props: { 
      'docpath': String,
      'docpaths': Array, //multiLink app
      'apptId': Number,
      'remitType': String,
      'apptType': String,
      'sigs': Array,
      'bankInfo': Object,
      'v$': Object,
      'remitAssign': Object
   },
   data() {
      return {
         loading: true,
         gettingSigs: true,
         waitTimeMS: 1000, //1 seconds
         signatures: [],
         sigCommDt: null,
         sigCommAgt: null,
         sigComm: null,
         remitanceType: '',
         banking: {},
         downloadfiletype: 1,
         keepdefaultcss: true,
         agentAgencyName: '',
         ssnTaxID: '',
         maskedSsn:'',
         address1: '',
         stateCode: '',
         city: '',
         zip: ''
      };
   },
   computed: {
      ...mapGetters(["isVBInvitation", "isVBCustomInvitation"]),
      docPathArray: function() {
         let arr = (this.docpaths === null || this.docpaths === undefined) ? [] : this.docpaths
         return arr
      }
   },
   mounted() {
      // We are using the array above so if there is just one, put it in the array
      if (this.docpath && this.docpath!="") {
         this.docPathArray.push(this.docpath)
      }
      
      this.signatures = JSON.parse(JSON.stringify(this.sigs)) //deep copy
      if (this.bankInfo == null) {
         this.banking ={
            bankName: '',
            accountNumber: '',
            accountNumberLast4: '',
            routingNumber: '',
            accountName: '',
            bankInfoTypeCode: '',
            accountTypeCode: ''                  
         }
      } else {
         this.banking = JSON.parse(JSON.stringify(this.bankInfo)) //deep copy
      }
      this.remitanceType = this.remitType
      this.storeSignatures()

      if (this.remitAssign != null) {
         this.agentAgencyName = this.remitAssign.agentAgencyName
         this.ssnTaxID = this.remitAssign.ssnTaxID
         this.maskedSsn = this.remitAssign.maskedSsn
         this.address1 =  this.combineForDisplay(this.remitAssign)
         this.stateCode = this.remitAssign.stateCode
         this.city = this.remitAssign.city
         this.zip = this.remitAssign.zip
      }

      this.gettingSigs = false
      this.chg()
	},
   methods: {
     combineForDisplay(ra) {
         if (!ra) return;

         const a1 = (ra.address1 || '').trim();
         const a2 = (ra.address2 || '').trim();

         // display combined value: prefer "a1a2", or single one if the other is empty
         return a1 ? (a2 ? `${a1}${a2}` : a1) : a2 || '';
      },
      storeSignatures() {
         this.sigCommDt = this.signatureByType('SIGTYP_COMSCHED_DT')
         if (this.sigCommDt==null) {
            let sig = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_COMSCHED_DT',
               signatureValue: ''
            }
            this.sigCommDt = this.signatures.length
            this.signatures.push(sig)
         } else {
            this.signatures[this.sigCommDt].signatureValue = 
               moment(this.signatures[this.sigCommDt].signatureValue, moment.ISO_8601).format('YYYY-MM-DD')
         }
         this.sigCommAgt = this.signatureByType('SIGTYP_COMSCHED_AGT')
         if (this.sigCommAgt==null) {
            let sig2 = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_COMSCHED_AGT',
               signatureValue: this.$store.getters.agentName
            }
            this.sigCommAgt = this.signatures.length
            this.signatures.push(sig2)
         }
         this.sigComm = this.signatureByType('SIGTYP_COMSCHED')
         if (this.sigComm==null) {
            let sig3  = {
               appointmentId: this.apptId,
               signatureTypeCode: 'SIGTYP_COMSCHED',
               signatureValue: this.$store.getters.signature
            }
            this.sigComm = this.signatures.length
            this.signatures.push(sig3)
         }
      },
      signatureByType(typ) {
         if (this.signatures === undefined) return null
         let i = null
         this.signatures.forEach((element, indx) => {
            if (element.signatureTypeCode == typ) {
               i = indx
            }
         })
         return i
      },
      showType(tarr) {
         return this.$parent.showType(tarr, this.apptType)
      },
      chg() {
         let ri = null
         // if there is something to save
         if ((this.agentAgencyName+this.ssnTaxID+this.address1+this.stateCode+this.zip).length>0)
         {
            ri = this.remitAssign ?? {}
            ri.agentAgencyName = this.agentAgencyName
            ri.ssnTaxID = this.ssnTaxID
            ri.address1 = this.address1
            ri.address2 = ''
            ri.stateCode = this.stateCode
            ri.city = this.city
            ri.zip = this.zip
         }

         this.$emit('update', 
            { 
               remitanceType: this.remitanceType, 
               signatures: this.signatures,
               remitAssign: ri,
               bankInfo: this.banking
            }
         )
      }      
   }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/colors.scss";
@import "../../assets/css/application.scss";
@import "../../assets/css/validation.scss";


.form-group label {
   text-align: right;
}
label {
   font-size: smaller;
}
.custom-control-input:checked ~ .custom-control-label::before {
   color: #fff;
   border-color: #000;
   background-color: #000;
}
.custom-control-label {
   display: inline-block;
   padding-top: 4px;
}
.col-form-label { 
   font-size: smaller;
   text-align: right;
   padding-right: 0;
}
</style>